import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=a84c636e"
import script from "./FloatingButton.vue?vue&type=script&lang=js"
export * from "./FloatingButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=a84c636e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports